export default __webpack_public_path__ + "static/media/sb.b11beb5e.png";